import { CommonModule } from '@angular/common';
import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertData, AlertModalService } from 'shared/core/services/alert-modal.service';
import { UserService } from 'shared/core/services/user/user.service';

@Component({
    selector: 'alert-toast',
    templateUrl: './alert-toast.component.html',
    styleUrls: ['./alert-toast.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule],
})
export class AlertToastComponent implements OnDestroy {
    public visible: boolean = false;
    public alertData: AlertData | null = null;
    public timerRunning: boolean = false;
    public acknowledgeTimer: number = 5;

    private timerInterval: any;
    private subscription: Subscription;

    constructor(
        private userService: UserService,
        private alertModalService: AlertModalService
    ) {
        this.subscription = this.alertModalService.toast$.subscribe(
            (alert: AlertData | null) => {
                if (!alert) return;
                this.alertData = alert;
                this.visible = true;
                this.startTimer();
            }
        );
    }

    public acknowledge(): void {
        this.alertModalService.acknowledge(this.alertData?.id);
        this.hide();
    }

    public sendWebinarInvite(slot: string): void {
        this.alertModalService.acknowledge(this.alertData?.id);
        this.alertModalService.sendWebinarInvite(this.userService.user, slot);
        this.hide();
    }

    public hide(): void {
        this.visible = false;
        this.alertData = null;
        this.clearTimer();
    }

    private startTimer(): void {
        this.timerRunning = true;
        this.acknowledgeTimer = 5;
        this.timerInterval = setInterval(() => {
            this.acknowledgeTimer--;
            if (this.acknowledgeTimer <= 0) {
                this.timerRunning = false;
                this.clearTimer();
            }
        }, 1000);
    }

    private clearTimer(): void {
        clearInterval(this.timerInterval);
        this.timerRunning = false;
        this.acknowledgeTimer = 5;
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.clearTimer();
    }
}
